import { render } from "./linkPassCard.html?vue&type=template&id=4591b6ba&scoped=true&ts=true&external"
import script from "./LinkPassCard.vue?vue&type=script&lang=ts"
export * from "./LinkPassCard.vue?vue&type=script&lang=ts"

import "./LinkPassCard.vue?vue&type=style&index=0&id=4591b6ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4591b6ba"]])

export default __exports__